const buildObjectFromArray = function buildObjectFromArray(arr, val) {
  return arr.reduceRight((obj, key, index) => ({ [key]: index === arr.length - 1 ? val : obj }), {})
}

export { buildObjectFromArray }
